import React, { useContext } from 'react';
import { Menu, Sidebar } from 'semantic-ui-react';
import { NavLink} from 'react-router-dom';
import { Context } from '../../context/globalContext';
import { routes } from '../../helpers/routes';
import { toast } from 'react-toastify';

export default function LateralMenu({ children }) {
  const {
    state: { showMenu, user },
    dispatch: { changeShowMenu },
  } = useContext(Context);

  function refreshPage() {
    window.location.reload(false);
  }

  function goToSynapse(email,password,host) {

    fetch(`https://${host}/api/v1/login`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        user: email,
        password: password
      })
    })
    .then((r) => r.json())
    .then((res) => {
      const userId = res?.data?.userId;
      const token = res?.data?.authToken;
      console.log(userId,token)
      window.open(
        `https://${host}/home?resumeToken=${token}&userId=${userId}`, 
        "_blank"
      )
    })
    .catch((error) => {
      toast.error("An error ocurred");
      console.error(error);
    });
    
  }

  return (
    <Sidebar.Pushable>
      <Sidebar
        as={Menu}
        animation="push"
        icon="labeled"
        inverted
        vertical
        visible={showMenu}
        onHide={() => changeShowMenu(false)}
        width="thin"
      >
        <Menu.Item onClick={() => changeShowMenu(false)} as={NavLink} to="/">
          Home
        </Menu.Item>
        <Menu.Item
          onClick={() => changeShowMenu(false)}
          as={NavLink}
          to={routes.MARKET_PLACE}
        >
          Marketplace
        </Menu.Item>
        <Menu.Item
          onClick={() => changeShowMenu(false)}
          as={NavLink}
          to={routes.PEOPLE}
        >
          Members
        </Menu.Item>
        <Menu.Item
          onClick={() => changeShowMenu(false)}
          as={NavLink}
          to={routes.SCHOOLS}
        >
          Schools
        </Menu.Item>
        <Menu.Item
          onClick={() => changeShowMenu(false)}
          as={NavLink}
          to={routes.APLICANTDB}
        >
          Applicant Database
        </Menu.Item>  
        <Menu.Item
          onClick={() => changeShowMenu(false)}
          as={NavLink}
          to={routes.NEWS}
        >
          News & Media
        </Menu.Item> 
        <Menu.Item
          onClick={() => changeShowMenu(false)}
          as={NavLink}
          to={routes.CONFESSIONS}
        >
          Confessions
        </Menu.Item>
        <Menu.Item
          onClick={() => changeShowMenu(false)}
          as={NavLink}
          to={routes.EXPERIENCES}
        >
          CV Generator
        </Menu.Item>    
        <Menu.Item
          onClick={() => {
            changeShowMenu(false);
            goToSynapse(user.email,process.env.REACT_APP_ROCKET_PASS,process.env.REACT_APP_ROCKET_HOST);
          }}
        >
          Gaba Synapse
        </Menu.Item>   
          
      </Sidebar>
      <Sidebar.Pusher dimmed={showMenu}>{children}</Sidebar.Pusher>
    </Sidebar.Pushable>
  );
}
